/* global axios */
import WMTSCapabilities from 'ol/format/WMTSCapabilities'
import WMTS, { optionsFromCapabilities } from 'ol/source/WMTS'
import { Tile as TileLayer } from 'ol/layer'

const axiosInstance = axios.create({
  headers: { Authorization: `Basic ${process.env.MIX_WMTS_TOKEN}` }
})
axiosInstance.defaults.headers.common = {}

const wmtsLayer = () => {
  const urlCreator = window.URL || window.webkitURL
  const tileLoader = (tile, src) => {
    axiosInstance.get(src, {
      responseType: 'blob'
    })
      .then(response => response.data)
      .then(imageData => {
        tile.getImage().src = urlCreator.createObjectURL(imageData)
      })
  }

  return new Promise(resolve => {
    axiosInstance.get(`${process.env.MIX_WMTS_ENDPOINT}?request=GetCapabilities&version=1.0.0&service=wmts`)
      .then(response => response.data)
      .then(text => {
        const parser = new WMTSCapabilities()
        const result = parser.read(text)
        const options = optionsFromCapabilities(result, {
          layer: 'topowebb_nedtonad',
          matrixSet: '3857',
          crossOrigin: 'anonymous'
        })

        const source = new WMTS(options)
        source.setTileLoadFunction(tileLoader)

        const tileLayer = new TileLayer({
          className: 'tileLayer',
          zIndex: 0,
          opacity: 1,
          source: source
        })

        resolve(tileLayer)
      })
  })
}

export default wmtsLayer
